export default __webpack_public_path__ + "static/media/Bags.310ff83d.jpeg";